import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=38d69954&scoped=true&"
import script from "./UserInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserInfo.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=38d69954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d69954",
  null
  
)

export default component.exports